import { AxiosError, AxiosResponse, AxiosStatic } from "axios"
import { StudentExchangeNonPartnerWidget } from "@/apps/StudentExchangeNonPartnerWidget/models/store-viewmodel"

export default (http: AxiosStatic, resource = '/api/studentexchange') => ({
    getOverview(language: string): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .get(`${resource}/overview/${language}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    postStudentExchangePartner(programId: number, privacyPolicyAgreed: boolean, crisisManagementTermsAgreed: boolean): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .post(`${resource}/partner/add`, {
                    programId: programId,
                    privacyPolicyAgreed: privacyPolicyAgreed,
                    crisisManagementTermsAgreed: crisisManagementTermsAgreed
                }).then((response: AxiosResponse) => {
                    console.log(response.data)
                    resolve(response)
                }).catch((error: AxiosError) => {
                    reject(error.response)
                    throw error
                })
        })
    },
    getStudentExchangeNonPartner(language: string, exchangeId: string): Promise<AxiosResponse> {
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .get(`${resource}/nonpartners/${exchangeId}/${language}`)
                .then((response: AxiosResponse) => {
                    resolve(response)
                })
                .catch((error: AxiosError) => {
                    reject(error.response)
                })
        })
    },
    postStudentExchangeNonPartner({ period, contact, institution, insurance, exchangeId, programId, academicYearId }: StudentExchangeNonPartnerWidget): Promise<AxiosResponse> {
        let action = exchangeId ? 'update' : 'add'
        return new Promise<AxiosResponse>((resolve, reject) => {
            http
                .post(`${resource}/nonpartner/${action}`,
                    {
                        "academicYear": `${academicYearId}`,
                        "agreeCrisisManagementInsurance": insurance.agreement,
                        "exchangeId": `${exchangeId ?? ""}`,
                        "cityPartnerInstitute": institution.city,
                        "countryPartnerInstitute": institution.country,
                        "namePartnerInstitute": institution.name,
                        "programOfStudyId": `${programId}`,
                        "contactVunetId": "",
                        "contactName": contact.name,
                        "contactEmail": contact.email,
                        "selectedMobilityType":  period.reason,
                        "fromDate": period.start,
                        "toDate": period.end
                    }
                ).then((response: AxiosResponse) => {
                    console.log(response.data)
                    resolve(response)
                }).catch((error: AxiosError) => {
                    reject(error.response)
                    throw error
                })
        })
    }
})
